import { createFileRoute, Link, notFound, Outlet } from "@tanstack/react-router";

/**
 * Layout route for /services/$slug and its children (e.g. /guides).
 *
 * This must render <Outlet /> only — the service page body lives in the
 * sibling leaf `services.$slug.index.tsx`. Previously this route rendered the
 * service page directly, which meant the child `/guides` route never mounted
 * and `/services/<slug>/guides/` silently served the service page instead.
 */
export const Route = createFileRoute("/services/$slug")({
  loader: async ({ params }) => {
    // Dynamic import keeps the ~120 KB services content module out of the
    // client entry bundle; it is fetched only when a service route loads.
    const { getService } = await import("@/content/services");
    const service = getService(params.slug);
    if (!service) throw notFound();
    return { service };
  },
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div>
      <section className="container-page py-32 text-center">
        <h1 className="font-display text-4xl">Service not found</h1>
        <Link to="/services/" className="mt-6 inline-block text-primary">
          ← All services
        </Link>
      </section>
    </div>
  ),
});
